import type { Dtwin } from "~/modules/dtwin/models/Dtwin.interface";
import type { DtwinModel } from "~/modules/dtwin/models/DtwinModel.interface";

export function findDtwinModel(models: DtwinModel[], dtwin?: Dtwin | null) {
  return models.find(
    (model: DtwinModel) => model.uid === dtwin?.deviceModelUid,
  );
}
